import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VRow,{attrs:{"no-gutters":""}},[_c(VCol,{staticClass:"hidden-xs-only",attrs:{"cols":"3"}},[_c(VSubheader,[_vm._v(_vm._s(_vm.header))])],1),_c(VCol,{staticClass:"content",attrs:{"cols":"12","sm":"9"}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }